// extracted by mini-css-extract-plugin
export default {"sidebar-thumb-width":"92","sidebarThumbWidth":"92","sidebar-thumb-height":"92","sidebarThumbHeight":"92","root":"IQY8I","grid-item":"_3r3Yc","gridItem":"_3r3Yc"};